import React from "react";
import { Link } from "react-router-dom";

import ROUTES from "config/routes";
import { getEventDates, getEventMonth } from "helpers/eventUtils";

const EventCard = ({ item }) => {
  return (
    <div className="card-item card-item--event event-item">
      <div className="event-item__row">
        <div className="event-item__date">
          <div className="event-item__day">{getEventDates(item)}</div>
          <div className="event-item__month">{getEventMonth(item)}</div>
        </div>
        <div className="event-item__title">
          <Link
            className="card-item__name card-item__link"
            to={`${ROUTES.events}/${item.id}`}
          >
            {item.name}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
